import { Box } from "@chakra-ui/react";
import { useEffect, useRef } from "react";
import { AppLink, PlaybackButton } from "@/components";
import { HERO } from "@/content";
import { usePlaybackToggle } from "@/hooks";

const { viewer } = HERO;

export const HeroViewer = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { isPlaying, toggle } = usePlaybackToggle();

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    if (isPlaying) {
      video.play().catch(() => {});
    } else {
      video.pause();
    }
  }, [isPlaying]);

  return (
    <>
      <AppLink
        href={viewer.href}
        external
        data-group
        display="block"
        position="relative"
        w="100%"
        sx={{ aspectRatio: "16 / 9" }}
        bg="#141414"
        overflow="hidden"
      >
        <video
          ref={videoRef}
          src={viewer.src}
          poster={viewer.poster}
          width={viewer.width}
          height={viewer.height}
          aria-label={viewer.alt}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />

        <Box
          position="absolute"
          top={{ base: "10px", sm: "14px" }}
          left={{ base: "10px", sm: "14px" }}
          display="flex"
          alignItems="center"
          gap="8px"
          px="14px"
          py="9px"
          borderRadius="sm"
          bg="rgba(10, 10, 10, 0.55)"
          color="#fff"
          transitionProperty="background-color"
          transitionDuration="0.25s"
          transitionTimingFunction="brand"
          _groupHover={{ bg: "brand.600" }}
        >
          <Box aria-hidden="true" fontSize="1rem" lineHeight={1}>
            ↻
          </Box>
          <Box as="span" fontSize="small" fontWeight="medium" textTransform="uppercase" letterSpacing="0.02em">
            {viewer.gateLabel}
          </Box>
        </Box>
      </AppLink>
      <PlaybackButton isPlaying={isPlaying} onToggle={toggle} />
    </>
  );
};
